module.exports = __webpack_public_path__ + "img/lunbo153.2c7af93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo153.png
// module id = Sj6e
// module chunks = 0